export const CLIENT_ROUTE = '/article';
export const API_ROUTE = '/api/article';
export const CLIENT_TITLE = 'Мэдээ';